/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { LayoutForm } from "./flota";
import { Col, Row } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { Redirect } from "react-router";
import ReCAPTCHA from "react-google-recaptcha";
import { Button, Input, Select, Checkbox } from "antd";
import clienteAxios from "../../../configAxios/configAxios";
import { errorSwal, redireccionSwal } from "../../../helper/swalHelpers";
import { Label } from "../../views/contactanos/contactanos";
import {
  useComunas,
  useConcesionariosRegion,
  useRegiones,
  useParametrosActivos,
  useValidaciones,
  useRubros
} from "../../../hooks/Front/formularios/useFormularios";
import {
  checkIsNotEmpty,
  formateaRut,
  tipeoNumero,
  tipeoRut,
  validarNumero,
  validarRut,
  validateEmail,
} from "../../../helper/validations";

import iconCorrect from "../../../img/Iconos/icon_correct.svg";
import iconIncorrect from "../../../img/Iconos/icon_incorrect.svg";

import "./index.css";
import { useLocation, useParams } from "react-router";

const DatosUsuario = ({ states, userData, producto, datosForms }) => {
  const location = useLocation();
  const { idRegion: idRegSlug, idConcesionario: idConSlug, idOficina: idOfSlug } = location.state
    ? location.state
    : { idRegion: undefined, idConcesionario: undefined, idOficina: undefined };

  const { seccion } = useParams();

  const [form, setForm] = useState({
    rut: undefined,
    nombres: undefined,
    apellidos: undefined,
    telefono: undefined,
    email: undefined,
    region: undefined,
    comuna: undefined,
    cargoEmpresa: undefined,
    nombreEmpresa: undefined,
    rubroEmpresa: undefined,
    rutEmpresa: undefined,
    idConcesionario: undefined,
    servicio: undefined,
    idOficina: undefined
  });
  const [servicio, setServicio] = useState(undefined);

  const [validar, setValidar] = useState({ name: undefined, value: undefined });
  const [captcha, setCaptcha] = useState(null);
  const [terminos, setTerminos] = useState(true);
  const [mailing, setMailing] = useState(true);
  const [loading, setLoading] = useState(false);
  const [redirigir, setRedirigir] = useState(undefined);

  const [datos, setDatos] = useState({
    Tipo: undefined,
    Rut: undefined,
    Nombre: undefined,
    Apellidos: undefined,
    Telefono: undefined,
    Email: undefined,
    Region: undefined,
    Comuna: undefined,
    rutEmpresa: undefined,
    nombresEmpresa: undefined,
    rubroEmpresa: undefined,
    cargoEmpresa: undefined,
    idVehiculo: undefined,
    idVersion: undefined,
    idRepuesto: undefined,
    valorEspecifico: undefined,
    tipoVehiculo: undefined,
    Equipamiento: undefined,
    Unidades: undefined,
    Comentario: undefined,
  });

  const {
    rut,
    nombres,
    apellidos,
    telefono,
    email,
    region,
    comuna,
    cargoEmpresa,
    nombreEmpresa,
    rubroEmpresa,
    rutEmpresa,
    idConcesionario,
  } = form;

  const handleChange = ({ target: { name, value } }) => {
    setForm({ ...form, [name]: value });
  };

  const changeRuts = ({ target: { name, value } }) => {
    let rutformat = formateaRut(value, "puntos");
    if (value.length > 1) {
      setForm({ ...form, [name]: rutformat });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleChangeTerminos = ({ target: { checked } }) => {
    setTerminos(checked)
  };

  const handleChangeSelect = (name, value) => {
    if (name === "region") {
      if (idConSlug) {
        setForm({ ...form, [name]: value, comuna: undefined });
        return;
      }
      setForm({
        ...form,
        [name]: value,
        comuna: undefined,
        idConcesionario: undefined,
      });
      return;
    }
    if (name === 'idConcesionario') {
      // let idx = concesionarios.findIndex(c => c.idConcesionario === value);
      // let conc = concesionarios[idx];
      setForm({
        ...form,
        [name]: value
        // idOficina: conc ? conc.idOficina : undefined
      });
      return;
    }
    setForm({ ...form, [name]: value });
  };

  function onChangeCaptcha(value) {
    if (value) setValidaciones({ ...validaciones, reCaptcha: "formulario-success" })
    setCaptcha(value);
  }

  const validateForm = () => {
    if (!seccion || (seccion !== "mercado-publico" && seccion !== "flotas")) {
      if (!checkIsNotEmpty(rut)) { setValidaciones({ ...validaciones, rut: "error-formulario" }); return false; }
      if (!validarRut(rut)) { setValidaciones({ ...validaciones, rut: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(nombres)) { setValidaciones({ ...validaciones, nombres: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(apellidos)) { setValidaciones({ ...validaciones, apellidos: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(telefono)) { setValidaciones({ ...validaciones, telefono: "error-formulario" }); return false; }
      if (!validarNumero(telefono)) { setValidaciones({ ...validaciones, telefono: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(email)) { setValidaciones({ ...validaciones, email: "error-formulario" }); return false; }
      if (!validateEmail(email)) { setValidaciones({ ...validaciones, email: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(region)) { setValidaciones({ ...validaciones, region: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(comuna)) { setValidaciones({ ...validaciones, comuna: "error-formulario" }); return false; }
      if (!captcha) { setValidaciones({ ...validaciones, reCaptcha: "error-formulario" }); return false; }
      // if (
      //   !terminos
      // )
        // return false;
    } else {
      if (!checkIsNotEmpty(rut)) { setValidaciones({ ...validaciones, rut: "error-formulario" }); return false; }
      if (!validarRut(rut)) { setValidaciones({ ...validaciones, rut: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(nombres)) { setValidaciones({ ...validaciones, nombres: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(apellidos)) { setValidaciones({ ...validaciones, apellidos: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(telefono)) { setValidaciones({ ...validaciones, telefono: "error-formulario" }); return false; }
      if (!validarNumero(telefono)) { setValidaciones({ ...validaciones, telefono: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(email)) { setValidaciones({ ...validaciones, email: "error-formulario" }); return false; }
      if (!validateEmail(email)) { setValidaciones({ ...validaciones, email: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(region)) { setValidaciones({ ...validaciones, region: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(comuna)) { setValidaciones({ ...validaciones, comuna: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(nombreEmpresa)) { setValidaciones({ ...validaciones, nombreEmpresa: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(rubroEmpresa)) { setValidaciones({ ...validaciones, rubroEmpresa: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(cargoEmpresa)) { setValidaciones({ ...validaciones, cargoEmpresa: "error-formulario" }); return false; }
      if (!checkIsNotEmpty(rutEmpresa)) { setValidaciones({ ...validaciones, rutEmpresa: "error-formulario" }); return false; }
      if (!validarRut(rutEmpresa)) { setValidaciones({ ...validaciones, rutEmpresa: "error-formulario" }); return false; }
      if (!captcha) { setValidaciones({ ...validaciones, reCaptcha: "error-formulario" }); return false; }
      // if (
      //   !terminos
      // )
        // return false;
    }
    return true;
  };

  // const handleContinue = () => {
  // if (!validateForm()) {
  //   errorSwal(
  //     "Ocurrió un error",
  //     "Recuerda ingresar todos los campos requeridos.",
  //     "Ok"
  //   );
  //   return;
  // }

  //   states.setFormU(form);
  //   states.setPaso(2);
  // };

  useEffect(() => {
    if (form) {
      states.setFormU(form);
    }
  }, [form]);


  const handleBack = () => {
    states.setFormU(form);
    states.setPaso(0);
  };

  const changeInput = (e) => {
    setValidar({ name: e.target.name, value: e.target.value });
  };

  const blurSelects = (nombre, value) => {
    setValidar({ name: nombre, value: value });
  };

  const [validaciones, setValidaciones] = useValidaciones(validar, form);


  const { parametros: legales, loading: loadingLeg, error: errorLeg } = useParametrosActivos('LEGAL');
  const [pdfPrivacidad, setPdfPrivacidad] = useState(undefined);

  const { regiones, loading: loadingR, error: errorR } = useRegiones();
  const { rubros, loading: loadingRub, error: errorRub } = useRubros();
  const { comunas, loading: loadingC, error: errorC } = useComunas(region);
  const {
    concesionarios,
    loading: loadingCon,
    error: errorCon,
  } = useConcesionariosRegion(region, servicio);

  useEffect(() => {
    if (legales) {
      setPdfPrivacidad(legales.find((item) => item.Etiqueta === "DATOS_PERSONALES"))
    }
  }, [legales])


  const IconoInput = (nombre) => {
    if (nombre === undefined || nombre.length < 1) return null;
    else if (nombre === "formulario-success")
      return <img src={iconCorrect} alt="icon" />;
    else return <img src={iconIncorrect} alt="icon" />;
  };

  useEffect(() => {
    if (states.formProducto) {
      let producto = states.formProducto;
      if (producto.tipo === "vehiculo") {
        setForm({ ...form, servicio: "venta" })
        setServicio("venta");
      }
      else if (producto.tipo === "mantencion") {
        setForm({ ...form, servicio: "servicio" })
        setServicio("servicio")
      }
      else if (producto.tipo === "repuesto") {
        setForm({ ...form, servicio: "repuestos" })
        setServicio("repuestos")
      }
    }
  }, [states.formProducto]);

  useEffect(() => {
    if (idRegSlug && idConSlug) {
      setForm({ ...form, region: idRegSlug, idConcesionario: idConSlug, idOficina: idOfSlug });
    }
  }, [idRegSlug, idConSlug]);


  useEffect(() => {
    const formProducto = datosForms.formProducto
      ? datosForms.formProducto
      : undefined;
    const formUsuario = datosForms.formUsuario
      ? datosForms.formUsuario
      : undefined;

    if (formProducto && formUsuario) {
      if (formProducto.tipo === "vehiculo") {
        setDatos({
          Tipo: formProducto.tipo,
          Unidades: formProducto.cantidad,
          idVersion: formProducto.idVersion,
          idVehiculo: producto.idVehiculo,
          Rut: formUsuario.rut,
          Nombre: formUsuario.nombres,
          Apellidos: formUsuario.apellidos,
          Comuna: formUsuario.comuna,
          Region: formUsuario.region,
          Telefono: formUsuario.telefono,
          Email: formUsuario.email,
          idConcesionario: 0,
          source: states.queryURL.utm_source ?? '',
          medium: states.queryURL.utm_medium ?? '',
          campaign: states.queryURL.utm_campaign ?? ''
        });
        return;
      }
      if (formProducto.tipo === "mantencion") {
        setDatos({
          Tipo: formProducto.tipo,
          idVersion: formProducto.idVersion,
          valorEspecifico: formProducto.mantencion,
          idVehiculo: formProducto.idModelo,
          Rut: formUsuario.rut,
          Nombre: formUsuario.nombres,
          Apellidos: formUsuario.apellidos,
          Comuna: formUsuario.comuna,
          Region: formUsuario.region,
          Telefono: formUsuario.telefono,
          Email: formUsuario.email,
          idConcesionario: formUsuario.idConcesionario,
          source: states.queryURL.utm_source ?? '',
          medium: states.queryURL.utm_medium ?? '',
          campaign: states.queryURL.utm_campaign ?? ''
        });
        return;
      }
      if (formProducto.tipo === "flotas") {
        setDatos({
          Tipo: formProducto.tipo,
          tipoVehiculo: formProducto.tipoVehiculos,
          Equipamiento: formProducto.equipamiento,
          Comentario: formProducto.comentarios,
          Unidades: formProducto.cantidad,
          Rut: formUsuario.rut,
          Nombre: formUsuario.nombres,
          Apellidos: formUsuario.apellidos,
          Comuna: formUsuario.comuna,
          Region: formUsuario.region,
          Telefono: formUsuario.telefono,
          Email: formUsuario.email,
          nombresEmpresa: formUsuario.nombreEmpresa,
          cargoEmpresa: formUsuario.cargoEmpresa,
          rubroEmpresa: formUsuario.rubroEmpresa,
          rutEmpresa: formUsuario.rutEmpresa,
          source: states.queryURL.utm_source ?? '',
          medium: states.queryURL.utm_medium ?? '',
          campaign: states.queryURL.utm_campaign ?? ''
        });
        return;
      }
      if (formProducto.tipo === "mercado-publico") {
        setDatos({
          Tipo: formProducto.tipo,
          idVehiculo: formProducto.idModelo,
          Unidades: formProducto.cantidad,
          Rut: formUsuario.rut,
          Nombre: formUsuario.nombres,
          Apellidos: formUsuario.apellidos,
          Comuna: formUsuario.comuna,
          Region: formUsuario.region,
          Telefono: formUsuario.telefono,
          Email: formUsuario.email,
          nombresEmpresa: formUsuario.nombreEmpresa,
          cargoEmpresa: formUsuario.cargoEmpresa,
          rubroEmpresa: formUsuario.rubroEmpresa,
          rutEmpresa: formUsuario.rutEmpresa,
          source: states.queryURL.utm_source ?? '',
          medium: states.queryURL.utm_medium ?? '',
          campaign: states.queryURL.utm_campaign ?? ''
        });
        return;
      }
      if (formProducto.tipo === "repuesto") {
        setDatos({
          Tipo: formProducto.tipo,
          idRepuesto: formProducto.idRepuesto,
          idVehiculo: formProducto.idVehiculo,
          valorEspecifico: formProducto.comentarios,
          Unidades: formProducto.cantidad,
          Rut: formUsuario.rut,
          Nombre: formUsuario.nombres,
          Apellidos: formUsuario.apellidos,
          Comuna: formUsuario.comuna,
          Region: formUsuario.region,
          Telefono: formUsuario.telefono,
          Email: formUsuario.email,
          idConcesionario: formUsuario.idConcesionario,
          idFamiliaRepuesto: formProducto.idCategoriaRepuesto,
          source: states.queryURL.utm_source ?? '',
          medium: states.queryURL.utm_medium ?? '',
          campaign: states.queryURL.utm_campaign ?? ''
        })
      }
    }
  }, [datosForms]);

  const handleSubmit = async () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLoading(true);
    if (!validateForm()) {
      errorSwal(
        "Ocurrió un error",
        "Recuerda ingresar todos los campos requeridos.",
        "Ok"
      );
      setLoading(false);
      return;
    }
    const formProducto = datosForms.formProducto
      ? datosForms.formProducto
      : undefined;
    try {
      let response = await clienteAxios.post("Cotizacion/crear", {...datos, Mailing: mailing ? 1 : 0});

      if (response.status === 201 && response.data.data.RSPTA === 0) {
        if (formProducto.tipo === "flotas") {
          redireccionSwal("Cotización enviada exitosamente", "Nos comunicaremos contigo a la brevedad", "ok", "/");
          return;
        }
        if (formProducto.tipo === "mercado-publico") {
          setRedirigir({
            pathname: "/cotizacion/ok",
            state: {
              producto: producto,
              usuario: datosForms.formUsuario,
              tipo: "mercado"
            },
          });
          return;
        }
        if (formProducto.tipo === "vehiculo") {
          setRedirigir({
            pathname: "/cotizacion/ok",
            state: {
              producto: producto,
              usuario: datosForms.formUsuario,
              tipo: "vehiculo"
            },
          });
          return;
        }
        setRedirigir({
          pathname: "/cotizacion/ok",
          state: {
            producto: producto,
            usuario: datosForms.formUsuario,
            tipo: undefined
          },
        });
        return;
      }
      // crear pagina para error
    } catch (error) {
      setRedirigir({
        pathname: "/cotizacion/rechazado",
        state: {
          producto: undefined,
          usuario: undefined,
          tipo: undefined
        },
      });
      return;
      //crear pagina para error
    }
  };

  const getViewPortWidth = () => {
    let viewportwidth;
    // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
    if (typeof window.innerWidth != 'undefined') {
      viewportwidth = window.innerWidth;
      // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
    } else
      if (typeof document.documentElement != 'undefined' &&
        typeof document.documentElement.clientWidth != 'undefined' &&
        document.documentElement.clientWidth != 0) {
        viewportwidth = document.documentElement.clientWidth;
        // older versions of IE
      } else {
        viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
      }
    return viewportwidth;
  }

  if (redirigir) return <Redirect to={redirigir} />;

  return (
    <>
      {seccion && (seccion === "mercado-publico" || seccion === "flotas") && (
        <>
          <LayoutForm>
            <p className="bold-title-hyundai f-responsive mb-3">
              {seccion === "mercado-publico" ? "Datos de la Institución" : "Datos de la empresa"}
            </p>
            <Label texto={seccion === "mercado-publico" ? "Institución pública" : "Empresa o razón social"} />
            <Input
              className={`agenda-input`}
              onChange={handleChange}
              name="nombreEmpresa"
              maxLength={50}
              value={nombreEmpresa}
              onBlur={changeInput}
            />
            {validaciones.nombreEmpresa === "error-formulario" && (
              <p className="texto-error-input f-responsive">
                {seccion === "mercado-publico" ? "No olvides ingresar el nombre de la institución" : "No olvides ingresar el nombre de la empresa"}
              </p>
            )}
          </LayoutForm>
          <LayoutForm>
            <Label texto="Rubro" />
            <Select
              className="w-100 hyundai-select"
              onBlur={() => blurSelects("rubroEmpresa", rubroEmpresa)}
              value={rubroEmpresa}
              onChange={(value) => handleChangeSelect("rubroEmpresa", value)}
            >
              {rubros &&
                errorRub === false &&
                loadingRub === false &&
                rubros.length > 0 &&
                rubros.map((rubro, i) => (
                  <Select.Option value={rubro.Valor} key={i}>
                    {rubro.Descripcion}
                  </Select.Option>
                ))}
            </Select>
            {/* <Input
              className={`agenda-input`}
              onChange={handleChange}
              name="rubroEmpresa"
              value={rubroEmpresa}
              maxLength={50}
              onBlur={changeInput}
            /> */}
            {validaciones.rubroEmpresa === "error-formulario" && (
              <p className="texto-error-input f-responsive">
                No olvides ingresar el rubro
              </p>
            )}
          </LayoutForm>
          <LayoutForm>
            <Label texto="Rut" />
            <Input
              className={`agenda-input`}
              onChange={changeRuts}
              name="rutEmpresa"
              value={rutEmpresa}
              maxLength={13}
              onKeyPress={(e) => tipeoRut(e)}
              onBlur={changeInput}
            />
            {validaciones.rutEmpresa === "error-formulario" && (
              <p className="texto-error-input f-responsive">
                No olvides ingresar un rut válido
              </p>
            )}
          </LayoutForm>
          <LayoutForm>
            <Label texto="Región" />
            <Select
              className="w-100 hyundai-select"
              onBlur={() => blurSelects("region", region)}
              value={region}
              onChange={(value) => handleChangeSelect("region", value)}
            >
              {regiones &&
                errorR === false &&
                loadingR === false &&
                regiones.length > 0 &&
                regiones.map((region, i) => (
                  <Select.Option value={region.idRegion} key={i}>
                    {region.Region}
                  </Select.Option>
                ))}
            </Select>
            {validaciones.region === "error-formulario" && (
              <p className="texto-error-input f-responsive">
                No olvides ingresar la región
              </p>
            )}
          </LayoutForm>

          <LayoutForm>
            <Label texto="Comuna" />
            <Select
              className="w-100 hyundai-select"
              onBlur={() => blurSelects("comuna", comuna)}
              value={comuna}
              onChange={(value) => handleChangeSelect("comuna", value)}
            >
              {comunas &&
                errorC === false &&
                loadingC === false &&
                comunas.length > 0 &&
                comunas.map((comuna, i) => (
                  <Select.Option value={comuna.idComuna} key={i}>
                    {comuna.Comuna}
                  </Select.Option>
                ))}
            </Select>
            {validaciones.comuna === "error-formulario" && (
              <p className="texto-error-input f-responsive">
                No olvides ingresar la comuna
              </p>
            )}
          </LayoutForm>
        </>
      )}
      <LayoutForm>
        <p className="bold-title-hyundai f-responsive  mb-3">
          Datos de contacto
        </p>
        <Label texto="Rut" />
        <Input
          className={`cotizar-input ${validaciones.rut}`}
          name="rut"
          onChange={changeRuts}
          suffix={IconoInput(validaciones.rut)}
          value={rut}
          onKeyPress={(e) => tipeoRut(e)}
          maxLength={13}
          onBlur={changeInput}
        />
        {validaciones.rut === "error-formulario" && (
          <p className="texto-error-input f-responsive">
            No olvides ingresar un rut válido
          </p>
        )}
      </LayoutForm>
      <LayoutForm>
        <Label texto="Nombres" />
        <Input
          className={`cotizar-input ${validaciones.nombres}`}
          name="nombres"
          suffix={IconoInput(validaciones.nombres)}
          value={nombres}
          onChange={handleChange}
          onBlur={changeInput}
        />
        {validaciones.nombres === "error-formulario" && (
          <p className="texto-error-input f-responsive">
            No olvides ingresar tu nombre
          </p>
        )}
      </LayoutForm>
      <LayoutForm>
        <Label texto="Apellidos" />
        <Input
          className={`cotizar-input ${validaciones.apellidos}`}
          name="apellidos"
          value={apellidos}
          suffix={IconoInput(validaciones.apellidos)}
          onChange={handleChange}
          onBlur={changeInput}
        />
        {validaciones.apellidos === "error-formulario" && (
          <p className="texto-error-input f-responsive">
            No olvides ingresar tus apellidos
          </p>
        )}
      </LayoutForm>
      {seccion && (seccion === "mercado-publico" || seccion === "flotas") && (
        <LayoutForm>
          <Label texto={seccion === "mercado-publico" ? "Cargo Institución Pública" : "Cargo empresa"} />
          <Input
            className={`cotizar-input ${validaciones.cargoEmpresa}`}
            name="cargoEmpresa"
            value={cargoEmpresa}
            suffix={IconoInput(validaciones.cargoEmpresa)}
            onChange={handleChange}
            onBlur={changeInput}
          />
          {validaciones.cargoEmpresa === "error-formulario" && (
            <p className="texto-error-input f-responsive">
              No olvides ingresar tu cargo
            </p>
          )}
        </LayoutForm>
      )}
      <LayoutForm>
        <Label texto="Teléfono celular" />
        <Input
          className={`cotizar-input ${validaciones.telefono}`}
          name="telefono"
          onBlur={changeInput}
          suffix={IconoInput(validaciones.telefono)}
          value={telefono}
          onChange={handleChange}
          prefix="+569"
          maxLength={8}
          onKeyPress={(e) => tipeoNumero(e)}
          onPaste={(e) => e.preventDefault()}
        />
        {validaciones.telefono === "error-formulario" && (
          <p className="texto-error-input f-responsive">
            No olvides ingresar un numero de teléfono válido
          </p>
        )}
      </LayoutForm>
      <LayoutForm>
        <Label texto="Email" />
        <Input
          className={`cotizar-input ${validaciones.email}`}
          name="email"
          suffix={IconoInput(validaciones.email)}
          value={email}
          onChange={handleChange}
          onBlur={changeInput}
        />
        {validaciones.email === "error-formulario" && (
          <p className="texto-error-input f-responsive">
            Verifica que tú email contenga @ y .
          </p>
        )}
      </LayoutForm>
      {!seccion || (seccion !== "mercado-publico" && seccion !== "flotas") ? (
        <>
          <LayoutForm>
            <Label texto="Región" />
            <Select
              className="w-100 hyundai-select"
              onBlur={() => blurSelects("region", region)}
              value={region}
              onChange={(value) => handleChangeSelect("region", value)}
            >
              {regiones &&
                errorR === false &&
                loadingR === false &&
                regiones.length > 0 &&
                producto && producto.restricciones && producto.restricciones.length > 0  ?
                regiones.map((region, i) => (
                  producto.restricciones.some((item) => item.idRegion === region.idRegion) &&
                  <Select.Option value={region.idRegion} key={i}>
                    {region.Region}
                  </Select.Option>
                )) :
                regiones.map((region, i) => (
                  <Select.Option value={region.idRegion} key={i}>
                    {region.Region}
                  </Select.Option>
                ))
              }
            </Select>
            {validaciones.region === "error-formulario" && (
              <p className="texto-error-input f-responsive">
                No olvides ingresar tu región
              </p>
            )}
          </LayoutForm>
          <LayoutForm>
            <Label texto={producto && producto.restricciones && producto.restricciones.length > 0  ? 'Sucursal' : 'Comuna' } />
            <Select
              className="w-100 hyundai-select"
              onBlur={() => blurSelects("comuna", comuna)}
              value={comuna}
              onChange={(value) => handleChangeSelect("comuna", value)}
            >
              {comunas &&
                errorC === false &&
                loadingC === false &&
                comunas.length > 0 &&
                producto && producto.restricciones && producto.restricciones.length > 0  ?
                comunas.map((comuna, i) => (
                  producto.restricciones.some((item) => item.idComuna === comuna.idComuna) &&
                  <Select.Option value={comuna.idComuna} key={i}>
                    {comuna.Comuna}
                  </Select.Option>
                )) :
                comunas.map((comuna, i) => (
                  <Select.Option value={comuna.idComuna} key={i}>
                    {comuna.Comuna}
                  </Select.Option>
                ))
              }
            </Select>
            {validaciones.comuna === "error-formulario" && (
              <p className="texto-error-input f-responsive">
                No olvides ingresar tu comuna
              </p>
            )}
          </LayoutForm>
          {(seccion !== "vehiculo" && (states.formProducto && states.formProducto.tipo !== "vehiculo")) &&
            <LayoutForm>
              <Label texto="Concesionario" />
              <Select
                className="w-100 hyundai-select"
                onBlur={() => blurSelects("idConcesionario", idConcesionario)}
                value={idConcesionario}
                onChange={(value) => handleChangeSelect("idConcesionario", value)}
                disabled={idConSlug ? true : false}
              >
                {concesionarios &&
                  errorCon === false &&
                  loadingCon === false &&
                  concesionarios.length > 0 &&
                  concesionarios.map((concesionario, i) => (
                    <Select.Option value={concesionario.idOficina} key={i}>
                      {concesionario.Nombre} - {concesionario.Sucursal}
                    </Select.Option>
                  ))}
              </Select>
              {validaciones.idConcesionario === "error-formulario" && (
                <p className="texto-error-input f-responsive">
                  No olvides ingresar el concesionario
                </p>
              )}
            </LayoutForm>
          }
        </>
      ) : undefined}
      <LayoutForm>
        <Row className="mx-0 mb-3">
          {/*<Col xs={"auto"} className="px-0">*/}
          {/*  <Checkbox className="parrafo-hyundai" checked={terminos} onChange={handleChangeTerminos}></Checkbox>*/}
          {/*</Col>*/}
          <Col className="pl-1 pr-0">
            <span className="d-block d-md-inline parrafo-hyundai f-responsive-10 pl-0 mb-0">El cliente autoriza libre y voluntariamente a la Compañía para que realice la recolección y almacenamiento de mis datos personales recogidos mediante el presente formulario, con la finalidad de cotizar un vehículo y contactarse con un ejecutivo.</span>
            {/*<span className="d-block d-md-inline parrafo-hyundai f-responsive-10 pl-0 mb-0">Acepto ser contactado por Hyundai Vehículos Comerciales SpA y/o su <Link to="/concesionarios" className="text-decoration-underline" target={"_blank"}>Red de Concesionarios</Link> y/o su partner financiero (FORUM Servicios Financieros S.A.), para recibir más información asociada a esta cotización, como así también para recibir información comercial, promociones y comunicaciones de marketing a través de medios electrónicos y/o de forma telefónica, entre otros. Revisa <a href={pdfPrivacidad && pdfPrivacidad.Valor} target="_blank" rel="noreferrer">aquí</a> la Autorización de Uso de Datos Personales. Privacidad</span>*/}
          </Col>
        </Row>
        <Row className="mx-0">
          <Col xs={"auto"} className="px-0">
            <Checkbox className="parrafo-hyundai" checked={mailing} onChange={(value) => setMailing(value.target.checked)}></Checkbox>
          </Col>
          <Col className="pl-1 pr-0">
            <span className="d-block d-md-inline parrafo-hyundai f-responsive-10 pl-0 mb-0">El cliente autoriza de manera libre y voluntaria para que sus datos personales sean tratados y usados para ser contactado por Hyundai Vehiculos Comerciales Chile SpA, su Red de Concesionarios y/o sus Partners Financieros, para recibir más información asociada al vehículo e información comercial, promociones y comunicaciones de marketing a través de medios electrónicos y/o de forma telefónica, conforme a la <a href={pdfPrivacidad && pdfPrivacidad.Valor} target="_blank" rel="noreferrer">Política de Privacidad</a></span>
          </Col>
        </Row>
      </LayoutForm>
      <Row>
        <Col xs={"auto"} md={"auto"} className="mx-auto mt-2 mb-3">
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
            onChange={onChangeCaptcha}
          />
          {validaciones.reCaptcha === "error-formulario" && (
            <p className="texto-error-input f-responsive">
              No olvides validar el captcha
            </p>
          )}
        </Col>
      </Row>

      {
        getViewPortWidth() <= 768 ? (
          <div className='col-btn-formulario-cotizar'>
            <Button
              className="btn-primario-cotizador font-btn w-100 f-responsive mb-3"
              onClick={handleSubmit}
              loading={loading}
            >
              Enviar
            </Button>
          </div>
        ) : (
          <LayoutForm>
            <Row>
              <Col xs={6} md={5} className="ml-auto">
                <Button
                  onClick={handleBack}
                  className="btn-secundario font-btn w-100 f-responsive mb-5"
                >
                  Volver
                </Button>
              </Col>
              <Col xs={6} md={5} className="ml-auto">
                <Button
                  className="btn-primario font-btn w-100 f-responsive mb-5"
                  onClick={handleSubmit}
                  loading={loading}
                >
                  Enviar
                </Button>
              </Col>
            </Row>
          </LayoutForm>
        )
      }
    </>
  );
};

export default DatosUsuario;
